import React from 'react';
import api from '../../../api';
import { IGetAnnouncementsRes, IGetAnnouncementsParams } from '../../../types/api/announcement/getAnnouncements';

export const useFetchAllAnnouncements = (
  shouldInitFetch: boolean = false, //初回fetchをするかどうか
  lang: string | null
) => {
  const [announcements, setAnnouncements] = React.useState<IGetAnnouncementsRes>();

  const fetchAllAnnouncements = async () => {
    const params: IGetAnnouncementsParams = { lang };
    const result = await api.get('/announcements', { params });
    setAnnouncements(result);
  };

  React.useEffect(() => {
    if (!shouldInitFetch) return;
    fetchAllAnnouncements();
  }, []);

  return { announcements, fetchAllAnnouncements };
};
